// Libraries
import React from 'react';
// Components
import { BreadCrumb, TerminalTab } from '../../components';

const EditTerminal = () => {

    return (
        <div className="create-merchant-wrap" id="create-merchant-section">
            <div className="bread-crumbs">
                <h3> Update Terminal ID </h3>
                <BreadCrumb
                    breadCrumbs={[
                        {
                            name: 'Terminal ID Onboarding',
                            link: '/tid-onboarding',
                        },
                        {
                            name: 'Update Terminal ID',
                            link: '',
                        },
                    ]}
                />
            </div>
            <div className="create-merchant">
                <TerminalTab />
            </div>
        </div>
    );
};

export default EditTerminal;
